import React from 'react';

const LocationAdd = () => {
    return (
        <div>

        </div>
    );
};

export default LocationAdd;